<template>
    <div>
        <div class="create-space" @click="visible = true">
            <p class="plus">+</p>
            <p class="text">Create space</p>
        </div>

        <base-modal title="Create new space" :visible="visible" @close="close">
            <template v-if="!showMembers">
                <base-backend-errors :data="create.error"/>
                <space-form @submit="create_space" @cancel="close" :loading="create.loading"/>
            </template>

            <template v-else>
                <space-teams :space="create.data"/><br/>
                <space-members :space="create.data"/><br/>
                <base-button @click="close" icon="fas fa-check" class="is-primary" text="Complete"/>
            </template>
        </base-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SpaceForm from './SpaceForm.vue';
import SpaceTeams from './SpaceTeams.vue';
import SpaceMembers from './SpaceMembers.vue';

export default {
    name: 'SpaceCreate',
    components: { SpaceMembers, SpaceTeams, SpaceForm },
    data() {
        return { visible: false, showMembers: false };
    },
    computed: mapState('spaces', ['create']),
    methods: {
        create_space(data) {
            this.$store.dispatch('spaces/create', data).then(() => {
                this.showMembers = true;
            });
        },
        close() {
            if (this.showMembers) {
                this.$store.dispatch('spaces/list');
            }
            this.visible = false;
            this.showMembers = false;
        },
    },
};
</script>

<style scoped>
    .create-space {
        display: flex;
        flex-direction: column;
        justify-content: center;
        border: dashed #d0d0d0 3px;
        height: 100%;
        color: #d0d0d0;
        line-height: 3.5rem;
        text-align: center;
    }

    .create-space > .plus {
        font-size: 6em;
    }

    .create-space > .text {
        font-size: 1.5em;
    }

    .create-space:hover {
        cursor: pointer;
        background: whitesmoke;
    }
</style>
